import type { WentOnlineAuthStatusDatagramBuf } from "~/classes/generated/status"
import type { WentOnlineAuthStatusDatagram } from "~/models/polycache/WentOnlineAuthStatusDatagram"

import { parseUserId } from "~/utils/flatbuffers/id"

const console = useLogger("status/went-online-auth")

export function handleWentOnlineAuthStatusDatagramBuf(buf: WentOnlineAuthStatusDatagramBuf) {
  const { emitInterfaceEvent } = useEvents()
  const { cacheState } = useCache()

  const datagram: WentOnlineAuthStatusDatagram = {
    userId: parseUserId(buf.userId()!),
    epochId: buf.epochId(),
  }

  console.debug("Successful authenticated connection to cache", datagram)
  cacheState.value.epochId = datagram.epochId
  cacheState.value.status = "readyAuth"
  cacheState.value.userId = datagram.userId
  cacheState.value.anonId = undefined
  cacheState.value.nextReconnectDate = undefined
  // Do any client login tasks, e.g. subscriptions?

  emitInterfaceEvent("wentOnlineAuthStatus", datagram)
}
